/* eslint-disable */
import axios from 'axios';
import interceptorsSetup from './utils/axios-interceptor';
/*
import settings from '../static/settings.json';

export const API = axios.create({
  baseURL: settings.baseURL
});
interceptorsSetup(API);
*/
/*
axios.get('settings.json')
.then(response => {console.warn("axios: ", response.data);})
.catch(e => console.error("axios error: %o",e));
*/

export let API = null;

export function ApiInit() {
	
	const api = axios.get('settings.json')
	.then(response => {
	//	settings = response.data;
		console.debug("axios settings.json: ", response.data);
		API = axios.create({
		  baseURL: response.data.baseURL
		});
		interceptorsSetup(API);
		return API;
	})
	.catch(e => console.error("Error al buscar promise de API %o", e));
	
	return Promise.all([api]);
}